import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface Recently {
	category: string;
	detailedUrl: string;
	goodsId: string;
	goodsName: string;
	imgUrl: string;
	information: string;
	type: "PKG" | "DMT" | "HOTEL" | "AIR" | "RENT" | "TOUR";
	userId: string;
	viewDate: string;
	webCustId: string;
	soldoutYn: string;
	changedUrl: string /* 일정변경 URL */;
	wishListYn: string /* wish Y | N */;
}

const key = "useGetRecently";
/** ```
 * 최근 본 상품 조회
 *   `/api/user/GetRecentlyViewed`
 * parameter
 *   `userId`
 *   `webCustId?`
 * ```*/
const getPath = (userId: string, webCustId: string): string =>
	`${publicRuntimeConfig.ENV_ESSENTIAL_API_BASEPATH}/api/user/recentlyViewed?userId=${userId}&webCustId=${webCustId}`;

/** ```
 * 최근 본 상품 조회
 *   `/api/user/GetRecentlyViewed`
 * parameter
 *   `userId`
 *   `webCustId?`
 * ```*/
const useGetRecently = (
	userId: string,
	webCustId = "",
	options?: Partial<UseQueryOptions<Response<{productResultList: Recently[]}>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath(userId, webCustId)],
		queryFn: () => useConfigureAxios({url: getPath(userId, webCustId), method: "GET"}).then(r => r.data),
		placeholderData: {body: {productResultList: []}},
		gcTime: Infinity,
		staleTime: Infinity,
		...options,
	});

export default useGetRecently;
export {getPath};
export type {Recently};
